<template>
  <v-card outlined>
    <div class="d-flex pa-4 my-2">
      <div class="d-flex mr-4">
        <v-skeleton-loader type="avatar" />
        <v-skeleton-loader type="avatar" class="ml-n2" />
      </div>
      <div class="w-100">
        <v-skeleton-loader type="text" width="200" />
        <v-skeleton-loader type="text" width="100" />
        <v-skeleton-loader type="text@2" class="mt-3" />
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RecognitionsCardSkeleton',
}
</script>
